import { render, staticRenderFns } from "./TenantUsuarioLogadoList.vue?vue&type=template&id=06befdc3&lang=html"
import script from "./TenantUsuarioLogadoList.vue?vue&type=script&lang=js"
export * from "./TenantUsuarioLogadoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports